import apiHelper from "./apiHelper";

export const deleteUserAdmin = async (id: string) => {
  const url = `/user/admin/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  return { error: true };
};

export const deleteCompanyAdmin = async (id: string) => {
  const url = `/company/admin/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  return { error: true };
};

export const updateUserAdmin = async (body: any) => {
  const url = "/user/admin/update";
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  return { error: true };
};

export const updateCompanyAdmin = async (body: any) => {
  const url = "/company/admin/update";
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  return { error: true };
};

export const addConsumerAdmin = async (body: any) => {
  const url = "/user/admin/create";
  try {
    const response: any = await apiHelper.post(url, { ...body });
    if (response.data.statusCode === 200) {
      return { success: true };
    }
    return { error: true };
  } catch (e) {
    return { error: true };
  }
};

export const addCompanyAdmin = async (body: any) => {
  const url = "/company/admin/create";
  try {
    const response: any = await apiHelper.post(url, { ...body });
    if (response.data.statusCode === 201) {
      return { success: true };
    }
    return { error: true };
  } catch (e) {
    return { error: true };
  }
};

export const getallUserTargetGroup = async () => {
  const url = "/user/admin/targetGroup/all";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};

export const getAllRecipts = async () => {
  const url = "/user/admin/reciepts/all";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};

export const getAllVouchers = async () => {
  const url = "/user/admin/voucher";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};

export const getAllInvoice = async () => {
  const url = "/company/admin/invoice";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};

export const sendMail = async (body: any) => {
  const url = "/company/admin/sendEmail";
  const response: any = await apiHelper.post(url, { ...body });
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  return { error: true };
};

// export const getMatchedUserTarget = async (id:string) => {
//     const url = `/user/admin/targetGroup/${id}`;
//     const response: any = await apiHelper('Get', url, {});
//     if (response.data.statusCode === 200) {
//         return { success: true, data: response.data.data };
//     }
//     return { error: true }
// }

export const getAllDocuments = async () => {
  const url = "/document";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true, data: [] };
};

export const getDocument = async (id: string) => {
  const url = `/document/${id}`;
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};

export const createDoc = async (title: string, content: string) => {
  const url = "/document";
  const response: any = await apiHelper.post(url, { title, content });
  if (response.data.statusCode === 201) {
    return { success: true, data: response.data.data };
  }
  return { error: true };
};

export const updateDoc = async (id: string, title: string, content: string) => {
  const url = `/document/${id}`;
  const response: any = await apiHelper.patch(url, { title, content });
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  return { error: true };
};

export const deleteDoc = async (id: string) => {
  const url = `/document/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  return { error: true };
};
